export default __webpack_public_path__ + "static/media/43_desktop.f53f31ab.jpg";